// node modules import
// import "regenerator-runtime/runtime";
import "whatwg-fetch";
import "core-js/web/url";
import VueMq from "vue-mq";
import Buefy, { ConfigProgrammatic } from "buefy";
import { abilitiesPlugin } from "@casl/vue";
import { Ability } from "@casl/ability";
import visibility from "vue-visibility-change";

// app module import
// import "./store";
import router from "./router";
import App from "./App.vue";
import appStore from "./store/appStore.js";
import "./validators/index.js";

// start qiankun
import { start } from "qiankun";
start();

// ---------------------------
// -- A Series of Vue Use ----
// ---------------------------
// 1. Use Buefy
window.Vue.use(Buefy);

import { format } from "date-fns";
ConfigProgrammatic.setOptions({
  defaultDatepickerYearsRange: [-100, 10],
  defaultDateFormatter: (date) => format(date, "dd/MM/yyyy"),
  defaultTimeFormatter: (time) => format(time, "HH:mm:ss"),
  defaultDatepickerMobileNative: false,
  defaultTimepickerMobileNative: false,
  defaultInputAutocomplete: "off",
});

// 2. User pagevisibility plugin
window.Vue.use(visibility);

// 2. Use VueMq
window.Vue.use(VueMq, {
  breakpoints: {
    smallMobile: 426,
    mobile: 769,
    tablet: 915,
    desktop: 1024,
    widescreen: 1216,
    fullhd: 1408
  }
});

// 3. Use @casl/vue
window.Vue.use(abilitiesPlugin, new Ability());

// -----------------
// -- App Mixin ----
// This is the right place to distribute reusable functionalities
// like common component that is used across app such as
// triggering a snackbar, fetching common data, etc
// -----------------
import globalMixin from "./mixins/globalMixin";

window.Vue.mixin(globalMixin);

window.Vue.filter("maskNRIC", function(nric) {
  const masker = "*****";
  const unmaskedString = nric.slice(5);
  return masker + unmaskedString;
});

/**
 * -----------------
 * Local Plugin
 * -----------------
 */
import api from "./plugins/api";
import date from "./plugins/date";
import upload from "./plugins/upload";
import files from "./plugins/files";
import recaptcha from "./plugins/recaptcha";
import wogaa from "./plugins/wogaa";
import profile from "./plugins/profile";
import commonRoute from "./plugins/commonRoute";
import validUuid from "./plugins/validUuid";

window.Vue.use(api, { router: router, store: appStore });
window.Vue.use(date);
window.Vue.use(upload, { store: appStore });
window.Vue.use(files, { store: appStore });
window.Vue.use(profile, { store: appStore });
window.Vue.use(commonRoute);
window.Vue.use(validUuid);

import IdleVue from "idle-vue";

import config from "./services/config";

config().then(configuration => {
  appStore.commit("config/setConfigurationData", configuration);
  appStore.commit(
    "auth/setConfigurationDataProperties",
    configuration.common_module.commonConfig
  );

  // Wogaa and Recaptcha plugin is coupled with configuration vuex
  window.Vue.use(recaptcha, { store: appStore });
  window.Vue.use(wogaa, { store: appStore });

  // Idle
  const SESSION_IDLE_TIME = appStore.state.auth.idleTime;

  const options = {
    eventEmitter: new window.Vue(),
    store: appStore,
    idleTime: SESSION_IDLE_TIME,
    events: ["mousemove", "keydown", "mousedown", "touchstart"],
    startAtIdle: false
  };
  window.Vue.use(IdleVue, options);
  // -----------------------------
  // -- Creating Vue Instance if the target element id present ----
  // -----------------------------
  const isElementExist = document.getElementById("common");
  if (isElementExist) {
    new window.Vue({
      name: "Common",
      el: "#common",
      router,
      store: appStore,
      render: h => h(App)
    });
  }
});
